export const UNIT_SYSTEMS = ["metric", "imperial"] as const;
export type UnitSystem = (typeof UNIT_SYSTEMS)[number];

/** Older compositions and unsupported preferences use metric displays. */
export function resolveUnitSystem(value: unknown): UnitSystem {
  return value === "imperial" ? "imperial" : "metric";
}
